<template>
    <div class="fullcol flex flex-col">
        <slot />
    </div>
</template>
